import { cn } from '@/lib/utils';

interface HtmlContentProps {
  html: string;
  className?: string;
  maxLines?: number;
}

/**
 * Componente per renderizzare contenuto HTML in modo sicuro
 * Supporta anche il line-clamp per limitare le righe visualizzate
 */
export const HtmlContent = ({ html, className, maxLines }: HtmlContentProps) => {
  if (!html) return null;

  // Per line-clamp, usiamo classi Tailwind predefinite
  const getContentClasses = () => {
    if (maxLines) {
      const lineClampClasses: Record<number, string> = {
        1: 'line-clamp-1',
        2: 'line-clamp-2',
        3: 'line-clamp-3',
        4: 'line-clamp-4',
        5: 'line-clamp-5',
      };
      return cn(className, lineClampClasses[maxLines] || `line-clamp-${maxLines}`);
    }
    return className;
  };

  return (
    <div
      className={getContentClasses()}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
